"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7839],{

/***/ 67839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CollectionSection": function() { return /* reexport */ CollectionSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/CollectionSection/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_collection_border_radius",
                label: "Border radius",
                type: "number",
                endAdornment: "px",
                default: theme.shape.borderRadius
            },
            {
                name: "theme_component_collection_background_color",
                label: "Background color",
                type: "color",
                default: "rgba(0, 0, 0, 0)"
            },
            {
                name: "theme_component_collection_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                default: 0,
                endAdornment: "px"
            },
            {
                name: "theme_component_collection_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
;// CONCATENATED MODULE: ./src/components/CollectionSection/CollectionSection.tsx








var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z, {
    target: "e7wqnia0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        borderRadius: theme.theme_component_collection_border_radius ? "".concat(theme.theme_component_collection_border_radius, "px") : theme.shape.borderRadius,
        backgroundColor: theme.theme_component_collection_background_color || "rgba(0, 0, 0, 0)",
        borderBottomWidth: theme.theme_component_collection_border_bottom_width ? "".concat(theme.theme_component_collection_border_bottom_width, "px") : 0,
        borderBottomColor: theme.theme_component_collection_border_bottom_color || theme.palette.divider,
        borderBottomStyle: "solid",
        "&:first-of-type": {
            marginTop: theme.spacing(0)
        },
        "&:last-of-type:not(:first-of-type)": {
            marginBottom: theme.spacing(0)
        }
    };
});
var CollectionSection = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useEditorHandlers("Collection Section"), other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/CollectionSection/index.ts



/***/ })

}]);